import { Flex, Empty } from "antd";
import Proptypes from "prop-types";

import "./EmptyData.style.less";

const EmptyData = ({ description }) => {
  return (
    <Flex align="center" justify="center" className="empty-data">
      <Empty description={description} />
    </Flex>
  );
};

EmptyData.propTypes = {
  description: Proptypes.string,
};

export default EmptyData;
